import { render, staticRenderFns } from "./TieHair.vue?vue&type=template&id=de7e1366&"
import script from "./TieHair.vue?vue&type=script&lang=js&"
export * from "./TieHair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports